import { CustomizerDataType } from "../../Type/Layout/ThemeCustomizerTypes";

export const navLinkList: CustomizerDataType[] = [
    {
        path: 'https://support.pixelstrap.com',
        image: '2.png',
        name: 'Support',
    },
    {
        path: 'https://docs.pixelstrap.net/react/wool/document',
        image: '3.png', 
        name: 'Document'
    },
    {
        path: 'https://landing.pixelstrap.net/react/wool/template/index.html',
        image: '4.png',
        name: 'Check Features'
    },
    {
        path: 'https://themeforest.net/user/pixelstrap/portfolio',
        image: '5.png',
        name: 'Buy Now'
    }
]

export const lightColorData = [
    {
        primary:"#6271EB",
        secondary:"#FF8575"
    },
    {
        primary:"#005F94",
        secondary:"#5391CA"
    },
    {
        primary:"#A155B9",
        secondary:"#F765A3"
    },
    {
        primary:"#2F9477",
        secondary:"#756600"
    },
    {
        primary:"#7c4dff",
        secondary:"#7b1fa2"
    },
    {
        primary:"#3949ab",
        secondary:"#4fc3f7"
    }
]

export const darkColorData = [
    {
        primary:"#6271EB",
        secondary:"#FF8575"
    },
    {
        primary:"#005F94",
        secondary:"#5391CA"
    },
    {
        primary:"#A155B9",
        secondary:"#F765A3"
    },
    {
        primary:"#2F9477",
        secondary:"#756600"
    },
    {
        primary:"#7c4dff",
        secondary:"#7b1fa2"
    },
    {
        primary:"#3949ab",
        secondary:"#4fc3f7"
    }
]